import { ResetPasswordForm, AuthLayout } from "features/auth/components";

export const ResetPassword = () => {
  return (
    <AuthLayout>
      <ResetPasswordForm />
    </AuthLayout>
  );
};
